import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m14.125 8.667-4.79 4.39a1.256 1.256 0 0 0 0 1.886 1.55 1.55 0 0 0 2.057 0l4.665-4.39c1.136-1.042 1.136-2.73 0-3.772-1.136-1.041-2.978-1.041-4.114 0l-4.665 4.39c-1.704 1.563-1.704 4.095 0 5.657 1.704 1.563 4.467 1.563 6.171 0L18 12.667",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };